<script lang="ts">
    import dayjs from "dayjs";

    export let workentry;
    export let qualifications;
</script>
{#if qualifications && workentry && workentry.startsAt}
<div class="grid grid-cols-7 gap-3">
    <span>{workentry.amount}</span>
    <span class="col-span-4">{qualifications.find(q => q.id === workentry.qualificationId)?.title}</span>
    <span>{(workentry.startsAt.value || workentry.startsAt).match(/\d{2}:\d{2}/)}</span>
    <span>{(workentry.endsAt.value || workentry.endsAt).match(/\d{2}:\d{2}/) }</span>
</div>
{/if}